import CircleUserIcon from '@ui-components-3/icons/lib/solid/CircleUser'
import HouseIcon from '@ui-components-3/icons/lib/solid/House'
import CalendarDaysIcon from '@ui-components-3/icons/lib/solid/CalendarDays'
import UserGroupIcon from '@ui-components-3/icons/lib/solid/UserGroup'
import CircleDollarIcon from '@ui-components-3/icons/lib/solid/CircleDollar'
import ClockIcon from '@ui-components-3/icons/lib/solid/Clock'
import MemoCircleInfoIcon from '@ui-components-3/icons/lib/solid/MemoCircleInfo'
import ChartPieIcon from '@ui-components-3/icons/lib/solid/ChartPie'
import User from 'singletons/User'

import {
  DASHBOARD_SCHEDULE,
  DASHBOARD_QUEUE,
  DASHBOARD_VISITS,
  DASHBOARD,
  DASHBOARD_POLICIES,
  DASHBOARD_PAYMENTS,
  DASHBOARD_MEMBERS,
  DASHBOARD_SCHEDULE_V1,
  DASHBOARD_REPORTS,
} from 'constants/routing'
import { SVGProps } from 'react'

export type MenuItem = {
  title: string
  exact?: boolean
  IconComponent: (props: SVGProps<SVGSVGElement>) => JSX.Element
  route: string
  getNotificationsAmount?: () => number
  isHidden?: boolean
}
const menuItems = () => {
  const { provider, isMemberIdFilterFlagEnabled, isReportsPageAvailable } = User
  const { visitQueue, paymentVisible, scheduleVersionConfig } = provider || {}

  const { showBothSchedules, showV1Schedule, showV3Schedule } = scheduleVersionConfig || {}

  const menuItemsArray: MenuItem[] = [
    {
      title: 'Home',
      exact: true,
      IconComponent: HouseIcon,
      route: DASHBOARD,
    },
    {
      title: `Schedule${showBothSchedules ? ' V1' : ''}`,
      IconComponent: CalendarDaysIcon,
      route: DASHBOARD_SCHEDULE_V1,
      isHidden: !showV1Schedule,
    },
    {
      title: `Schedule${showBothSchedules ? ' V3' : ''}`,
      IconComponent: CalendarDaysIcon,
      route: DASHBOARD_SCHEDULE,
      isHidden: !showV3Schedule,
    },
    {
      title: 'Queue',
      IconComponent: UserGroupIcon,
      getNotificationsAmount: () =>
        visitQueue?.queuedTalkNowAndMedicalVisits.length + visitQueue?.queuedCrisisVisits.length || 0,
      route: DASHBOARD_QUEUE,
    },
    {
      title: 'Members',
      IconComponent: CircleUserIcon,
      route: DASHBOARD_MEMBERS,
      isHidden: !isMemberIdFilterFlagEnabled,
    },
    {
      title: 'Payments',
      IconComponent: CircleDollarIcon,
      route: DASHBOARD_PAYMENTS,
      isHidden: !paymentVisible,
    },
    {
      title: 'Past Visits',
      exact: true,
      IconComponent: ClockIcon,
      route: DASHBOARD_VISITS,
    },
    {
      title: 'Reports',
      IconComponent: ChartPieIcon,
      route: DASHBOARD_REPORTS,
      isHidden: !isReportsPageAvailable,
    },
    {
      title: 'Policies',
      IconComponent: MemoCircleInfoIcon,
      route: DASHBOARD_POLICIES,
    },
  ]

  return menuItemsArray.filter(({ isHidden }) => !isHidden)
}
export default menuItems
